// extracted by mini-css-extract-plugin
export var container = "InfoCard-module--container--45edf";
export var content = "InfoCard-module--content--06b99";
export var title = "InfoCard-module--title--46ee9";